import React from 'react';
import { Col, Row } from 'react-bootstrap5';

import PropTypes from 'prop-types';
import Card from './Card';

export default function Index({ members }) {
  return (
    <section>
      <h6 className="mb-3 fw-semibold">Talent Rankings</h6>
      <Row>
        <Col key="members" md="4" className="mb-2 mb-md-0">
          <Card
            value={members?.filter((item) => item.attributes.talent_index_group === 'high').length}
            title="High Potential"
          />
        </Col>

        <Col md="4" className="mb-2 mb-md-0">
          <Card
            value={members?.filter((item) => item.attributes.talent_index_group === 'core').length}
            title="Core"
          />
        </Col>

        <Col md="4" className="mb-2 mb-md-0">
          <Card
            value={members?.filter((item) => item.attributes.talent_index_group === 'risk').length}
            title="At Risk"
          />
        </Col>

      </Row>

    </section>
  );
}

Index.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object),
};

Index.defaultProps = {
  members: null,
};
